import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ArticoloCoeff} from "../../../_models/ArticoloCoeff";
import {ArticoliService} from "../../../_services/articoli.service";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {SaveMessage} from "../../../_helpers/save-message";

@Component({
  selector: 'app-udm-converter',
  templateUrl: './udm-converter.component.html',
  styleUrls: ['./udm-converter.component.scss'],
})
export class UdmConverterComponent  implements OnInit {
  @Input() codArt = '';
  @Input() varianteArt = '';
  @Input() udM1 = '';
  @Input() udM2 = '';
  @Input() qtaUdM1 = 0;
  @Input() qtaUdM2 = 0;
  @Output() qtaUdM1Change = new EventEmitter<number>();
  @Output() qtaUdM2Change = new EventEmitter<number>();
  artCoeff: ArticoloCoeff;
  constructor(
    private organizzazioniService: OrganizzazioniService,
    private articoliService: ArticoliService,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    this.getArticoloCoeff();
  }

  getArticoloCoeff() {
    if (!this.codArt || this.codArt === '') {
      return false;
    }
    this.articoliService.searchCoeffOfArticolo(this.organizzazioniService.organizzazioneId, this.codArt,
      this.udM1, this.udM2)
      .then((coeff: ArticoloCoeff) => this.artCoeff = coeff)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei coefficienti."));
  }

  get isQuantitaValida(): boolean {
    return Math.abs(this.qtaUdM1 * this.artCoeff.coeffMagToDes - this.qtaUdM2) < 1/10*this.artCoeff.numDecUm2;
  }


  convertGiacenza(udmNum: number) {
    if (udmNum === 1) {
      this.qtaUdM2 = this.round(this.qtaUdM1 * this.artCoeff.coeffMagToDes, this.artCoeff.numDecUm2);
      this.qtaUdM2Change.emit(this.qtaUdM2);
    }
    if (udmNum === 2) {
      this.qtaUdM1 = this.round(this.qtaUdM2 / this.artCoeff.coeffMagToDes, this.artCoeff.numDecUmMag);
      this.qtaUdM1Change.emit(this.qtaUdM1);
    }
  }

  round(num: number, decimals: number): number {
    const factor = 10 ** decimals;
    return Math.round(num * factor) / factor;
  }
}
